import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface FoundCardState {
	card: string;
}

const initialState: FoundCardState = {
	card: '',
};

const foundCardSlice = createSlice({
	name: 'foundCard',
	initialState,
	reducers: {
		addCard(state, action: PayloadAction<string>) {
			state.card = action.payload;
		},
		clearCard(state) {
			state.card = '';
		},
	},
});

export const { addCard, clearCard } = foundCardSlice.actions;
export default foundCardSlice.reducer;
